import { useFlyOutProductsBasedOnSelectedCloud } from '../../../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import {
  ButtonV2,
  ModalConfirmV2,
  ModalSizeVariants,
} from '@labrav/react-components'
import { FooterV2 } from '../../../../common/components/FooterV2/FooterV2'
import { useStyles } from '../../AddEditProductListingFooter/AddEditProductListingFooter.styles'
import {
  FlyoutProductAddEditSectionName,
  FlyoutMicrosoftProductSections,
  pageMarkerType,
} from '../../../../types/addEditProduct'
import { FormikProps, useFormikContext } from 'formik'
import { useDispatch, useSelector } from '../../../../store/hooks'
import { useCallback, useEffect, useState } from 'react'
import { isEmpty } from 'lodash'
import {
  saveMicrosoftMigrationProduct,
  sendMicrosoftProduct,
} from '../../../../modules/addEditProduct/action'
import { useNavigate, useParams } from 'react-router-dom'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from '@mui/material'
import { faCircleCheck, faDeleteLeft } from '@fortawesome/pro-regular-svg-icons'
import { validateMicrosoftProductCreationFlow } from '../../../../common/utils/productCreationUtil'
import { buyerRegistrationPagePreviewMessage } from '../../../../common/utils/messagesConstants'
import {
  BuyerRegistrationPreviewButton,
  BuyerRegistrationPreviewModal,
} from '../../../../common/components/BuyerRegistrationPreviewComponents/BuyerRegistrationPreviewComponents'
import { ProductStatus } from '../../../../modules/productsListing/types'
import initialMSFTPoduct from '../../../../mocks/initialMSFTPoduct.json'
import { LoadingTypes, isLoading as Loading } from '@labrav/common'
export interface AddEditProductListingFooterProps {
  activeLink?: string
  setActiveLink: React.Dispatch<React.SetStateAction<string>>
  page: FlyoutProductAddEditSectionName
  userProfileId: string
  productId?: string
  enableUpdateMigrateList?: boolean
  handleSubmitForm: (handleSubmit: (status?: string) => void) => void
  setEnableUpdateMigrateList: React.Dispatch<React.SetStateAction<boolean>>
  isImpartner?: boolean
  hideMultipleSections?: boolean
}

export const AddEditProductListingFooter = ({
  activeLink,
  setActiveLink,
  page,
  productId,
  handleSubmitForm,
  enableUpdateMigrateList,
  setEnableUpdateMigrateList,
  isImpartner = false,
  hideMultipleSections = false,
}: AddEditProductListingFooterProps) => {
  const { classes } = useStyles({ isImpartner })
  const navigate = useNavigate()
  const {
    accountId,
    cloud,
    secureKey: secureKeyFromURL,
    partnerId: partnerIdFromURL,
  } = useParams<{
    accountId?: string
    cloud?: string
    secureKey?: string
    partnerId?: string
  }>()
  const { products } = useFlyOutProductsBasedOnSelectedCloud()
  const isLandingPage = activeLink === '/landing-page'
  const formikProps =
    useFormikContext() as FormikProps<FlyoutMicrosoftProductSections>
  const { values, errors, setValues, setTouched } = formikProps

  const isProductMigrationInProgress = !!products?.filter(
    item => item?.status === ProductStatus.PRODUCT_STATUS_MIGRATION_IN_QUEUE
  )?.length
  const [openModal, setOpenModal] = useState<boolean>(false)

  const handleCloseModal = useCallback(() => {
    setOpenModal(false)
  }, [openModal])

  const [openClearModal, setOpenClearModal] = useState<boolean>(false)

  const handleCloseClearModal = useCallback(() => {
    setOpenClearModal(false)
  }, [openClearModal])

  const dispatch = useDispatch()

  const { isLoading } = useSelector<{
    isLoading: boolean
  }>(state => ({
    isLoading: Loading(state.loading)(
      LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL
    ),
  }))

  const { isLoadingClear } = useSelector<{
    isLoadingClear: boolean
  }>(state => ({
    isLoadingClear: Loading(state.loading)(
      LoadingTypes.CLEAR_FLYOUT_PRODUCT_DETAIL
    ),
  }))

  const [isOpenModalMigrationDetails, setIsOpenModalMigrationDetails] =
    useState<boolean>(false)
  const [hasDraftSubmission, setHasDraftSubmission] = useState<boolean>(false)
  const showMigrationModal = useCallback(() => {
    setIsOpenModalMigrationDetails(true)
  }, [])
  const handleCloseMigration = useCallback(() => {
    setIsOpenModalMigrationDetails(false)
  }, [])

  const isMigratedPage =
    page === FlyoutProductAddEditSectionName.MIGRATION_DETAILS

  const selectedProductCount =
    values[FlyoutProductAddEditSectionName.MIGRATION_DETAILS].products?.length

  const descriptionModal = !isProductMigrationInProgress ? (
    <div>
      Confirm selection of{' '}
      <span className={classes.nameBoldText}>
        {selectedProductCount} product{selectedProductCount > 1 ? 's' : ''}{' '}
      </span>{' '}
      for migration?
      <div>
        The migration process will start upon completion of the listing steps.
      </div>
    </div>
  ) : (
    <div>
      Confirm changes in selection of products for migration?
      <div>
        You have selected{' '}
        <span className={classes.nameBoldText}>
          {selectedProductCount} product{selectedProductCount > 1 ? 's' : ''}
        </span>
        . The migration process will start upon completion of the listing steps.
      </div>
    </div>
  )

  const noErrorsForPreview = (errors: any): boolean => {
    const landingPageErrors =
      errors[FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS]

    return (
      !landingPageErrors?.bgColor &&
      !landingPageErrors?.buttonColor &&
      !landingPageErrors?.buttonTextColor &&
      !landingPageErrors?.headingMessage
    )
  }
  const allValuesFilledForPreview = !noErrorsForPreview(errors)

  useEffect(() => {
    if (values && !isImpartner) {
      const { pageMarker } = values
      if (!pageMarker?.page1) {
        setActiveLink('/product-details')
      } else if (!pageMarker?.page2) {
        setActiveLink('/landing-page')
      } else if (!pageMarker?.page3) {
        setActiveLink('/notification-recipients')
      } else {
        setActiveLink('/product-details')
      }
    }
    if (isImpartner) {
      setActiveLink('/product-details')
    }
  }, [isImpartner])

  const migrationProductCount = values?.migrationDetails?.products?.length

  const allOtherPageMarkersTrue = getAllOtherPageMarkersTrue({
    pageMarker: values?.pageMarker,
    sectionName: page,
    isImpartner,
  })

  const handleSuccess = () => {
    let pathname = `/flyout/azure/${accountId}/products-listing`

    if (isImpartner) {
      const pathWithSecureKey = `/external-apps/${secureKeyFromURL}/partners/${partnerIdFromURL}/flyout/${cloud}/${accountId}/products-listing/`
      const pathWithoutSecureKey = `/external-apps/partners/${partnerIdFromURL}/flyout/${cloud}/${accountId}/products-listing/`
      pathname = secureKeyFromURL ? pathWithSecureKey : pathWithoutSecureKey
    }

    navigate(pathname)
  }
  const handleSubmitApiCall = async (
    partnerId?: string,
    finalSubmit?: boolean
  ) => {
    await handleCloseModal()
    await handleCloseMigration()
    if (partnerId) {
      const isErrorInCurrentPage = validateMicrosoftProductCreationFlow(
        page,
        formikProps
      )
      const migrationProducts =
        values?.[FlyoutProductAddEditSectionName.MIGRATION_DETAILS].products

      if (!isErrorInCurrentPage) {
        if (page === FlyoutProductAddEditSectionName.MIGRATION_DETAILS) {
          const selectedProducts = migrationProducts?.map(
            item => item?.split('/')[1]
          )

          await dispatch(
            saveMicrosoftMigrationProduct({
              partnerId,
              products: selectedProducts,
              isUpdate: isProductMigrationInProgress,
              onSuccess: () => setEnableUpdateMigrateList(false),
            })
          )
        }
        const updatedForm = {
          ...values,
          [FlyoutProductAddEditSectionName.PAGE_MARKER]: {
            page1:
              !finalSubmit && isImpartner ? false : !!migrationProducts?.length,
            page2:
              page === FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS ||
              values?.[FlyoutProductAddEditSectionName.PAGE_MARKER]?.page2,
            page3:
              page ===
                FlyoutProductAddEditSectionName.NOTIFICATIONS_RECIPIENTS ||
              values?.[FlyoutProductAddEditSectionName.PAGE_MARKER].page3,
          },
        }

        const isDraft = isImpartner
          ? !updatedForm?.[FlyoutProductAddEditSectionName.PAGE_MARKER]?.page1
          : !updatedForm?.[FlyoutProductAddEditSectionName.PAGE_MARKER]
              ?.page1 ||
            !updatedForm?.[FlyoutProductAddEditSectionName.PAGE_MARKER]
              ?.page2 ||
            !updatedForm?.[FlyoutProductAddEditSectionName.PAGE_MARKER]?.page3
        await dispatch(
          sendMicrosoftProduct({
            formValues: updatedForm,
            partnerId,
            isDraft: isDraft,
            isFetch: true,
            ...(!isDraft ? { handleSuccess } : {}),
            isImPartner: isImpartner,
          })
        )

        const nextPage = await getNextPage(page)
        if (nextPage && isEmpty(status) && !isImpartner) {
          await setActiveLink(nextPage)
        }
      }
    }
  }
  const handleSubmit = async () => {
    if (accountId) {
      if (hideMultipleSections) {
        if (!hasDraftSubmission) {
          if (!isOpenModalMigrationDetails) {
            showMigrationModal()
            return
          }
          await handleSubmitApiCall(accountId, false)
          setHasDraftSubmission(true)
          return
        }

        if (!openModal) {
          setOpenModal(true)
          return
        }

        return
      } else {
        if (isMigratedPage && !isOpenModalMigrationDetails) {
          if (!enableUpdateMigrateList) {
            setActiveLink('/landing-page')
          } else {
            showMigrationModal()
          }
        } else {
          handleCloseMigration()
          if (allOtherPageMarkersTrue) {
            setOpenModal(true)
          } else {
            await handleSubmitApiCall(accountId)
          }
        }
      }
    }
  }

  const handleClickSubmit = () => {
    handleSubmitForm(handleSubmit)
  }

  const [open, setOpen] = useState<boolean>(false)
  const handleClose = () => {
    setOpen(false)
  }
  const handlePreview = () => {
    setOpen(true)
  }

  const handleFinalSubmit = async () => {
    if (!accountId) {
      return
    }
    if (isImpartner) {
      await handleSubmitApiCall(accountId, true)
    } else {
      await handleSubmitApiCall(accountId)
    }
  }

  const handleClearPage = () => {
    switch (page) {
      case FlyoutProductAddEditSectionName.MIGRATION_DETAILS:
        return {
          ...values,
          migrationDetails: {
            products: [],
          },
          pageMarker: {
            ...values?.pageMarker,
            page1: false,
          },
        }
      case FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS: {
        return {
          ...values,
          infoCollectionFormMetaData: {
            ...initialMSFTPoduct?.infoCollectionFormMetaData,
          },
          buyerFormFields: {
            ...initialMSFTPoduct?.buyerFormFields,
          },
          termsAndConditions: {
            ...values?.termsAndConditions,
            infoCollectionFormMetaData:
              initialMSFTPoduct?.termsAndConditions?.infoCollectionFormMetaData,
          },
          pageMarker: {
            ...values?.pageMarker,
            page2: false,
          },
        }
      }
      case FlyoutProductAddEditSectionName.NOTIFICATIONS_RECIPIENTS: {
        return {
          ...values,
          notificationRecipients: {
            ...initialMSFTPoduct?.notificationRecipients,
          },
          generalInformation: {
            ...initialMSFTPoduct?.generalInformation,
          },
          termsAndConditions: {
            ...values?.termsAndConditions,
            notificationRecipients:
              initialMSFTPoduct?.termsAndConditions?.notificationRecipients,
          },
          pageMarker: {
            ...values?.pageMarker,
            page3: false,
          },
        }
      }
      default:
        break
    }
  }

  const resetFormData = async () => {
    const productData = await handleClearPage()
    await setValues(productData as FlyoutMicrosoftProductSections)
    await setTouched({})
    await restFormApiCall(productData as FlyoutMicrosoftProductSections)
  }
  const clearSuccess = async () => {
    if (page === FlyoutProductAddEditSectionName.MIGRATION_DETAILS) {
      await setEnableUpdateMigrateList(true)
    }
    await handleCloseClearModal()
  }
  const restFormApiCall = useCallback(
    async (productData: FlyoutMicrosoftProductSections) => {
      if (accountId) {
        if (page === FlyoutProductAddEditSectionName.MIGRATION_DETAILS) {
          await dispatch(
            saveMicrosoftMigrationProduct({
              partnerId: accountId,
              products: [],
              isClear: true,
            })
          )
        }
        await dispatch(
          sendMicrosoftProduct({
            formValues: productData,
            partnerId: accountId,
            isDraft: true,
            isFetch: true,
            isClear: true,
            handleSuccess: clearSuccess,
            isImPartner: isImpartner,
          })
        )
      }
    },
    [values, accountId, errors, productId, page]
  )

  return (
    <div
      className={!hideMultipleSections ? classes.footerWrapper : ''}
      data-testid={'footer-wrapper'}
    >
      <FooterV2
        actions={
          <div
            className={clsx(
              classes.innerfooterWrapper,
              classes.footerRight,
              hideMultipleSections ? classes.footerWrapperIframe : ''
            )}
          >
            <div
              data-testid={'add-edit-product-footer'}
              className={classes.buttonWrapper}
            >
              {page === FlyoutProductAddEditSectionName.MIGRATION_DETAILS && (
                <p className={classes.productCount}>
                  {migrationProductCount} products selected
                </p>
              )}

              <div className={classes.buttonWrapper}>
                <>
                  <ButtonV2
                    data-testid={'clear-page'}
                    styleType="link"
                    onClick={() => setOpenClearModal(true)}
                  >
                    Clear page
                  </ButtonV2>
                  {isLandingPage && (
                    <div>
                      <BuyerRegistrationPreviewButton
                        allValuesFilledForPreview={allValuesFilledForPreview}
                        buyerRegistrationPagePreviewMessage={
                          buyerRegistrationPagePreviewMessage
                        }
                        handlePreview={handlePreview}
                      />
                    </div>
                  )}
                </>

                <div>
                  <ButtonV2
                    data-testid="submit-button"
                    styleType="primary"
                    onClick={handleClickSubmit}
                    loading={isLoading}
                  >
                    {allOtherPageMarkersTrue ? 'Submit' : 'Continue'}
                  </ButtonV2>
                </div>
              </div>
            </div>
          </div>
        }
        width={isImpartner ? 'calc(100% + 78px)' : 'calc(100% - 352px)'}
        customClass={classes.root}
      />

      <ModalConfirmV2
        title={'Migrate listing?'}
        description={
          <Typography className={classes.modalText}>
            <p>Are you sure you want to migrate the listing?</p>
            <p>
              Clicking 'Submit' will initiate the migration process. This will
              take approximately 5 to 10 minutes to move your products to Labra.
            </p>
          </Typography>
        }
        open={openModal}
        titleAcceptButton={'Submit'}
        onAccept={handleFinalSubmit}
        onDecline={handleCloseModal}
        variant={ModalSizeVariants.small}
        icon={
          <FontAwesomeIcon
            icon={faCircleCheck}
            style={{ width: '20px', height: '16px' }}
          />
        }
        hideCancelIcon={false}
        hideCancelButton={false}
      />
      <ModalConfirmV2
        title={'Clear page?'}
        description={
          <Typography className={classes.clearModalText}>
            <p>
              All the data filled in this page will be removed. You will have a
              empty page with blank fields which will have to be filled again.
            </p>
            <p>Are you sure you want to clear this page?</p>
          </Typography>
        }
        open={openClearModal}
        titleAcceptButton={'Clear page'}
        onAccept={resetFormData}
        onDecline={handleCloseClearModal}
        variant={ModalSizeVariants.medium}
        icon={
          <FontAwesomeIcon
            icon={faDeleteLeft}
            style={{ width: '18px', height: '16px' }}
          />
        }
        acceptLoading={isLoadingClear}
        hideCancelIcon={false}
        hideCancelButton={false}
      />

      <ModalConfirmV2
        title={
          !isProductMigrationInProgress
            ? 'Confirm selection?'
            : 'Update selection?'
        }
        description={descriptionModal}
        open={isOpenModalMigrationDetails}
        titleAcceptButton={!isProductMigrationInProgress ? 'Confirm' : 'Update'}
        onAccept={handleSubmit}
        onDecline={handleCloseMigration}
        variant={ModalSizeVariants.medium}
        acceptDisabled={false}
        icon={
          <FontAwesomeIcon
            icon={faCircleCheck}
            style={{ width: '20px', height: '16px' }}
          />
        }
      />

      <BuyerRegistrationPreviewModal open={open} handleClose={handleClose} />
    </div>
  )
}

export const getNextPage = (sectionName: FlyoutProductAddEditSectionName) => {
  if (sectionName === FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS) {
    return '/notification-recipients'
  } else if (
    sectionName === FlyoutProductAddEditSectionName.MIGRATION_DETAILS
  ) {
    return '/landing-page'
  }
}
type PageTypeMSFT =
  | 'notificationRecipients'
  | 'infoCollectionFormMetaData'
  | 'migrationDetails'

export const getAllOtherPageMarkersTrue = ({
  pageMarker,
  sectionName,
  isImpartner,
}: {
  pageMarker?: pageMarkerType
  sectionName: FlyoutProductAddEditSectionName
  isImpartner?: boolean
}) => {
  if (!pageMarker) return false

  const { page1, page2, page3 } = pageMarker
  const currentPage = getCurrentPage(sectionName as PageTypeMSFT)

  if (isImpartner) {
    return page1
  }
  if (currentPage === 'page1') {
    return page2 && page3
  } else if (currentPage === 'page2') {
    return page1 && page3
  } else if (currentPage === 'page3') {
    return page1 && page2
  }

  return false
}

const getCurrentPage = (sectionName: PageTypeMSFT): string => {
  const PageMapping: Record<PageTypeMSFT, string> = {
    [FlyoutProductAddEditSectionName.MIGRATION_DETAILS]: 'page1',
    [FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS]: 'page2',
    [FlyoutProductAddEditSectionName.NOTIFICATIONS_RECIPIENTS]: 'page3',
  }
  return PageMapping[sectionName] || 'page1'
}
